import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { Typography, Grid2, Slider, OutlinedInput, InputAdornment, Box, Button, Tabs, Tab } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import SquareIcon from '@mui/icons-material/Square';
import { backendHosts } from '../../../ui-utils/apiConfig';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import styles1 from "./Web.module.css";
// import Footer from '../landingpage/fotter';
import { borderRadius, color, styled } from '@mui/system';
import { useLanguage } from '../../../Context/LangContext';
import en from "../../../i18n/English/Home/cal.json"
import hi from "../../../i18n/Hindi/Home/cal.json";
import kn from "../../../i18n/Kannada/Home/cal.json"
import ma from "../../../i18n/Marathi/Home/cal.json";
import gu from "../../../i18n/Gujarati/Home/cal.json"
const CustomSlider = styled(Slider)(({ theme }) => ({
    color: "#7DAB1C",
    height: "2px",
    padding: '15px 0',
    '& .MuiSlider-thumb': {
        height: 16,
        width: 16,
        border: "1px solid #7DAB1C",
        backgroundColor: '#fff',
        boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
        '&:focus, &:hover, &.Mui-active': {
            boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
        },
        '&:before': {
            boxShadow:
                '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
        },
    },
    '& .MuiSlider-valueLabel': {
        display: "none"
    },
    '& .MuiSlider-track': {
        border: 'none',
        height: "2px",
    },
    '& .MuiSlider-rail': {
        backgroundColor: '#f1f1f1',
    }
}));

const styles = theme => ({
    buttonlabel: {
        width: "300px !important",
        textTransform: 'none !important', color: '#000000 !important', fontFamily: 'cardiuma-regular !important', fontSize: "calc(15px + var(--font-delta))  !important",
        "&:hover": {
            cursor: 'pointer'
        },
        "@media only screen and (max-device-width: 1500px)": {
            width: "230px !important",
        },
        "@media only screen and (max-device-width: 1200px)": {
            width: "160px !important",
        },
    },

    mainlayout: {
        padding: '20px 42px 15px 42px',
        display: 'flex',
        justifyContent: 'center',
        "@media screen and (max-width:960px)": {
            width: '100%', padding: '42px 16px 15px 16px',
        }
    },

    '@keyframes moveGradientFull': {
        '0%': {
            left: '0%',
        },
        '100%': {
            left: '100%',
            transform: 'translateX(-100%) translateY(-50%)',
        },
    },

    headingContainer: {
        position: 'relative',
        width: 'fit-content',
        padding: '10px 0px',
        backgroundColor: 'transparent',
        display: 'inline-block',
        zIndex: 2,
        justifyContent: 'center',
        margin: '0 auto', // center container
    },

    gradientBackground: {
        position: 'absolute',
        top: '85%',
        left: '0%',
        transform: 'translateY(-50%)',
        width: '87px',
        height: '88px',
        background:
            'linear-gradient(180deg, rgba(255, 229, 133, 0.8) 100%, rgba(231, 206, 255, 0.8) 85.67%, rgba(56, 72, 215, 0.8) 0%)',
        filter: 'blur(52px)',
        zIndex: 1,
        animation: '$moveGradientFull 3s ease-in-out infinite alternate', // prefix with $
    },

    heading: {
        position: "relative",
        zIndex: 1,
        color: '#FFF9F9 !important',
        fontFamily: 'Outfit600 !important',
        fontSize: "calc(42px + var(--font-delta)) !important",
        fontStyle: 'normal !important',
        lineHeight: '100% !important',
        marginTop:"90px",

        "@media screen and (max-width:960px)": {
            fontSize: "calc(30px + var(--font-delta))  !important",
            marginTop: "30px",

        }
    },

    main1: {
        marginTop: '90px',
        "@media screen and (max-width:960px)": {
            marginTop: '40px',
        }
    },
});

const MarginCalculator = ({ classes }) => {
    const [tabValue, setTabValue] = useState("1");
    const [monthlyInvestment, setMonthlyInvestment] = useState(500);
    const [timePeriod, setTimePeriod] = useState(10);
    const [expectedReturnRate, setExpectedReturnRate] = useState(12);
    const [stepUpPercentage, setStepUpPercentage] = useState(10);
    const [calculatorName, setCalculatorName] = useState("");
    const MotionGrid = motion(Grid2);
    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language];

    const navigate=useNavigate()
    useEffect(() => {
        document.body.style.backgroundColor = "#D7FFF4";

        if (tabValue === "1") {
            setCalculatorName("SIP Calculator");
        } else if (window.location.pathname === "/stepup-sip-calculator") {
            setCalculatorName("Step Up SIP Calculator");
        } else if (tabValue === "2") {
            setCalculatorName("Lumpsum Calculator");
        }

        setMonthlyInvestment(25000);
    }, [tabValue]);


    useEffect(() => {
        if (tabValue === "2") {
            if (monthlyInvestment > 10000000) {
                setMonthlyInvestment(10000000);
            }
        } else {
            if (monthlyInvestment > 1000000) {
                setMonthlyInvestment(1000000);
            }
        }

        if (stepUpPercentage > 50) {
            setStepUpPercentage(50);
        }

        if (expectedReturnRate > 30) {
            setExpectedReturnRate(30);
        } else if (expectedReturnRate === 0) {
            setExpectedReturnRate(12);
        }

        if (timePeriod > 40) {
            setTimePeriod(40);
        } else if (timePeriod === 0) {
            setTimePeriod(12);
        }
    }, [monthlyInvestment, stepUpPercentage, expectedReturnRate, timePeriod]);

    const calculateSIP = () => {
        let p = 0;
        let r = 0;
        let n = 0;

        if (tabValue === "1") {
            p = Number(monthlyInvestment);
            r = Number(expectedReturnRate / 100 / 12);
            n = Number(timePeriod * 12);

            const yearlyReturns = [];
            let maturityValue = 0;
            let totalInvestedAmount = 0;

            for (let year = 1; year <= timePeriod; year++) {
                const months = year * 12;

                const currentMaturityValue = p * ((Math.pow(1 + r, months) - 1) / r) * (1 + r);
                yearlyReturns.push({
                    year: year,
                    maturityValue: Math.round(currentMaturityValue),
                    investedAmount: Math.round(p * months)
                });

                totalInvestedAmount = p * months;
            }

            const finalMaturityValue = yearlyReturns[yearlyReturns.length - 1]?.maturityValue;
            const returns = finalMaturityValue - totalInvestedAmount;

            return {
                maturityValue: Math.round(finalMaturityValue),
                investedAmount: Math.round(totalInvestedAmount),
                estimatedReturns: Math.round(returns),
                yearlyReturns: yearlyReturns
            };
        }

        if (tabValue === "2") {
            const p = Number(monthlyInvestment);
            const r = Number(expectedReturnRate) / 100;
            const n = Number(timePeriod);

            let cumulativeValue = p;
            let totalInvestedAmount = p;
            let totalReturns = 0;
            let yearlyReturns = [];

            for (let year = 1; year <= n; year++) {
                const yearlyReturn = cumulativeValue * r;
                cumulativeValue += yearlyReturn;
                totalReturns = cumulativeValue - totalInvestedAmount;

                yearlyReturns.push({
                    year: year,
                    investedAmount: Math.round(totalInvestedAmount),
                    maturityValue: Math.round(cumulativeValue),
                    yearlyReturn: Math.round(yearlyReturn),
                });
            }

            return {
                maturityValue: Math.round(cumulativeValue),
                investedAmount: Math.round(totalInvestedAmount),
                estimatedReturns: Math.round(totalReturns),
                yearlyReturns: yearlyReturns,
            };
        }

        if (tabValue === "4") {
            const p = monthlyInvestment;
            const r = expectedReturnRate / 100 / 12;
            const n = timePeriod * 12;
            let totalValue = 0;
            let totalInvestedAmount = 0;

            let array = [];

            for (let year = 0; year < timePeriod; year++) {
                const monthlyInvestmentForYear = p * Math.pow(1 + stepUpPercentage / 100, year);
                totalInvestedAmount += monthlyInvestmentForYear * 12;

                for (let month = 0; month < 12; month++) {
                    const monthsRemaining = n - (year * 12 + month);
                    const futureValue = monthlyInvestmentForYear * Math.pow(1 + r, monthsRemaining);
                    totalValue += futureValue;
                }

                array.push({
                    maturityValue: Math.round(totalValue),
                    investedAmount: Math.round(totalInvestedAmount),
                    estimatedReturns: Math.round(totalValue - totalInvestedAmount)
                });
            }

            return {
                maturityValue: Math.round(totalValue),
                investedAmount: Math.round(totalInvestedAmount),
                estimatedReturns: Math.round(totalValue - totalInvestedAmount)
            };
        }
    };

    console.log(tabValue)

    const handleTabChange = (event, value) => {
        setTabValue(value);
    };

    const handleInvestmentChange = (e, value) => {
        setMonthlyInvestment(parseInt(e.target.value));
    };

    const handleStepUpPercentageChange = (e, value) => {
        setStepUpPercentage(parseInt(e.target.value));
    };

    const handleTimePeriodChange = (e, value) => {
        setTimePeriod(parseInt(e.target.value));
    };

    const handleReturnChange = (e, value) => {
        setExpectedReturnRate(parseFloat(e.target.value));
    };


    const font = {
        fontFamily: "Inter400 !important",
        color: "#3E3E3E !important"
    }

    return (
        <main className={styles1.main1}>
            {/* <MotionGrid className={classes.mainlayout}
                initial={{ opacity: 0, y: -300 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}> */}
             <Grid2 className={classes.mainlayout}>


                {/* <h1 className={classes.heading}>
                    {t.calculator}
                </h1> */}

                <div className={classes.headingContainer}>
                    <div className={classes.gradientBackground}></div>
                    <h1 className={classes.heading}>
                        {t.calculator}
                    </h1>
                </div>
            </Grid2>
            {/* </MotionGrid> */}

            {/* <MotionGrid className={styles1.menuOuterCard}
                initial={{ opacity: 0, x: -300 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}> */}
            <Grid2 className={styles1.menuOuterCard }>


                <Grid2 className={styles1.menuCard}>
                    <Tabs
                        sx={{
                            "& .MuiTab-root": {
                                minWidth: "175px",
                                padding: "12px 16px",
                                marginRight: "103px",
                                color: "#FFFFFF",
                                fontFamily: "Inter400",
                                textTransform: "none",
                                fontSize: "calc(20px + var(--font-delta))",
                                lineHeight: "24px",

                                "@media (max-width:1300px)": {
                                    marginRight: "80px",
                                },
                                "@media (max-width:1140px)": {
                                    marginRight: "50px",
                                    paddingLeft: "25px",
                                },
                                "@media (max-width:1100px)": {
                                    marginRight: "0px",
                                    paddingLeft: "22px",
                                },
                                "@media (max-width:940px)": {
                                    padding: "10px 8px 10px 13px",
                                    minWidth: "145px",
                                    marginRight: "15px",
                                },
                                "@media (max-width:900px)": {
                                    padding: "10px 5px 10px 10px",
                                    minWidth: "125px",
                                    marginRight: "18px",
                                },
                                "@media (max-width:730px)": {
                                    minWidth: "140px",
                                    marginRight: "10px",
                                    padding: "10px 30px 10px 10px",
                                },
                            },

                            // ✅ Selected tab styling
                            "& .MuiTab-root.Mui-selected": {
                                color: "#FCF8A9",
                                fontFamily: "Inter700",
                                fontSize: "calc(20px + var(--font-delta))",
                                lineHeight:"24px",
                                fontWeight:"700"
                            },

                            // Tab indicator styling
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#FCF8A9",
                                height: "3px",
                                width: "178px",

                                "@media (max-width:940px)": {
                                    width: "160px",
                                },
                                "@media (max-width:900px)": {
                                    width: "140px",
                                },
                                "@media (max-width:730px)": {
                                    width: "130px",
                                },
                            },
                        }}
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label={t.sip} value="1" />
                        <Tab label={t.lumpsum} value="2" />
                    </Tabs>


                </Grid2>
            </Grid2>
             {/* </MotionGrid> */}

            {/* <MotionGrid className={styles1.calculatorMainGrid}
                initial={{ opacity: 0, y: 300 }}
                animate={{ opacity: 1, y: 0 }}

                transition={{ duration: 0.6 }}> */}
            <Grid2 className={styles1.calculatorMainGrid}>


                <Grid2 className={styles1.calculatorSubGrid1}>

                    <Grid2 display="flex" justifyContent="space-between">
                        <Typography className={styles1.calculatorTxt}>{tabValue === "2" ? `${t.totalInvestment}` : `${t.monthlyInvestment}`}</Typography>
                        <OutlinedInput
                            type='number'
                            value={monthlyInvestment}
                            onChange={handleInvestmentChange}
                            size='small'
                            id="outlined-adornment-weight"
                            startAdornment={<InputAdornment position="start">
                                <span style={{ color: "#000000", fontWeight: 500 }}>₹</span>
                            </InputAdornment>}
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                                style: { marginLeft: "0px", textAlign: "right"}
                            }}
                            className={styles1.calculatorAmount}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                },
                            }}
                        />
                    </Grid2>
                    <CustomSlider
                        size="small"
                        onChange={handleInvestmentChange}
                        step={500}
                        max={tabValue === "2" ? 10000000 : 1000000}
                        value={monthlyInvestment}
                        aria-label="Small"
                        valueLabelDisplay="auto"
                        sx={{
                            color: "#6FA203",
                            '& .MuiSlider-thumb': {
                                backgroundColor: "#FFFFFF",
                            },
                            '& .MuiSlider-track': {
                                backgroundColor: "#6FA203",
                            },
                            '& .MuiSlider-rail': {
                                backgroundColor: "#E1E1E1",
                                height:"2px"
                            },
                            '& .MuiSlider-valueLabel': {
                                backgroundColor: "#6FA203",

                            }
                        }}
                    />
                    {tabValue === "4" &&
                        <Grid2>
                            <Grid2 display="flex" justifyContent="space-between">
                                <Typography className={styles1.calculatorTxt}>Annual step up</Typography>
                                <OutlinedInput
                                    type='number'
                                    value={stepUpPercentage}
                                    onChange={handleStepUpPercentageChange}
                                    size='small'
                                    id="outlined-adornment-weight"
                                    endAdornment={<InputAdornment sx={{ m: "2px 2px 0px 0px", fontFamily: "Inter400 !important" }}><span style={{ color: "#6FA203" }}>%</span></InputAdornment>}
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{

                                        style: { textAlign: 'right', marginRight: "5px", color: "#3E3E3E !important" }
                                    }}
                                    className={styles1.calculatorAmount}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none'
                                        },
                                    }}
                                />
                            </Grid2>
                            <CustomSlider size="small"
                                onChange={handleStepUpPercentageChange}
                                step={0.1}
                                max={50}
                                value={stepUpPercentage}
                                aria-label="Small"
                                valueLabelDisplay="auto" />
                        </Grid2>
                    }
                    <Grid2>
                        <Grid2 display="flex" justifyContent="space-between">
                            <Typography className={styles1.calculatorTxt}>{t.expectedReturnRate}</Typography>
                            <OutlinedInput
                                type='number'
                                value={expectedReturnRate}
                                onChange={handleReturnChange}
                                size='small'
                                id="outlined-adornment-weight"
                                endAdornment={<InputAdornment sx={{ m: "2px 2px 0px 0px" }}><span style={{ color: "#000000" }}>%</span></InputAdornment>}
                                aria-describedby="outlined-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                    style: { textAlign: 'right', marginRight: "5px" }
                                }}
                                className={styles1.calculatorAmount}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none'
                                    },
                                }}
                            />
                        </Grid2>
                        <CustomSlider size="small"
                            onChange={handleReturnChange}
                            max={30}
                            step={0.1}
                            value={expectedReturnRate}
                            aria-label="Small"
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#6FA203",
                                '& .MuiSlider-thumb': {
                                    backgroundColor: "#FFFFFF",
                                },
                                '& .MuiSlider-track': {
                                    backgroundColor: "#6FA203",
                                },
                                '& .MuiSlider-rail': {
                                    backgroundColor: "#E1E1E1",
                                    height: "2px"
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: "#6FA203",

                                }
                            }}/>
                    </Grid2>
                    <Grid2>
                        <Grid2 display="flex" justifyContent="space-between">
                            <Typography className={styles1.calculatorTxt}>{t.timePeriod}</Typography>
                            <OutlinedInput
                                type='number'
                                value={timePeriod}
                                onChange={handleTimePeriodChange}
                                size='small'
                                id="outlined-adornment-weight"
                                endAdornment={<InputAdornment sx={{ m: "2px 2px 0px 0px" }}><span style={{ color: "#000000" }}>{t.yr}</span></InputAdornment>}
                                aria-describedby="outlined-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                    style: { textAlign: 'right', marginRight: "5px" }
                                }}
                                className={styles1.calculatorAmount}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none'
                                    },
                                }}
                            />
                        </Grid2>
                        <CustomSlider size="small"
                            onChange={handleTimePeriodChange}
                            max={40}
                            value={timePeriod}
                            aria-label="Small"
                            valueLabelDisplay="auto"
                            sx={{
                                color: "#6FA203",
                                '& .MuiSlider-thumb': {
                                    backgroundColor: "#FFFFFF",
                                },
                                '& .MuiSlider-track': {
                                    backgroundColor: "#6FA203",
                                },
                                '& .MuiSlider-rail': {
                                    backgroundColor: "#E1E1E1",
                                    height: "2px"
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: "#6FA203",

                                }
                            }}/>
                    </Grid2>

                    {/* <Grid2 className={styles1.resultCard}> */}
                        <Grid2 className={styles1.calculationResult}>
                            <Grid2 display="flex" justifyContent="space-between">
                                <Typography className={styles1.investTxt} mr={1}>{t.investedAmount}</Typography>
                                <Typography className={styles1.investTxt} textAlign="start" >₹ {new Intl.NumberFormat('en-IN').format(calculateSIP()?.investedAmount || 0)}</Typography>
                            </Grid2>
                            <Grid2 display="flex" justifyContent="space-between">
                                <Typography className={styles1.investTxt}>{t.estimatedReturns}</Typography>
                                <Typography className={styles1.investTxt} textAlign="start" >₹ {new Intl.NumberFormat('en-IN').format(calculateSIP()?.estimatedReturns || 0)}</Typography>
                            </Grid2>
                            <Grid2 display="flex" justifyContent="space-between">
                                <Typography className={styles1.investTxt}>{t.totalValue}</Typography>
                                <Typography className={styles1.investTxt} textAlign="start" >₹ {new Intl.NumberFormat('en-IN').format(calculateSIP()?.maturityValue || 0)}</Typography>
                            </Grid2>
                        </Grid2>
                    {/* </Grid2> */}


                </Grid2>
                <Grid2 className={styles1.calculatorSubGrid2}>
                    <Grid2 sx={{
                        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", marginTop: tabValue === "4" ? "80px" : "0px", padding: "0px 0px",
                        "@media only screen and (max-width: 1000px)": {
                            marginTop: tabValue === "4" ? "0px" : "30px"
                        },
                        "@media only screen and (max-width: 480px)": {
                            padding: "0px 0px",
                        },
                    }}>
                        {tabValue !== "4" ? <Box
                            sx={{
                                display: "flex",
                                flexDirection: window.innerWidth < 500 ? "column" : "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "16px",
                            }}
                        >
                            {/* Pie Chart */}

                            <PieChart
                                series={[
                                    {
                                        data: [
                                            { label: `${t.investedAmountLabel}`, value: calculateSIP()?.investedAmount || 0, color: "#80A8D8" },
                                            { label: `${t.estimatedReturnLabel}`, value: calculateSIP()?.estimatedReturns || 0, color: "#097ABE" },
                                        ],
                                        innerRadius: 50,
                                        outerRadius: 80,
                                        cx: (window.innerWidth < 420 && 90) || (window.innerWidth < 480 && 90) || (window.innerWidth < 599 && 75) || 100,
                                    },
                                ]}
                                height={(window.innerWidth < 1000 && 200) || 200}
                                width={
                                    (window.innerWidth < 420 && 200) ||
                                    (window.innerWidth < 480 && 200) ||
                                    (window.innerWidth < 599 && 190) ||
                                    (window.innerWidth < 599 && 200) ||
                                    (window.innerWidth > 600 && window.innerWidth < 1100 && 210) ||
                                    210
                                }
                                slotProps={{
                                    legend: {
                                        hidden: true,
                                    },
                                }}
                            />

                            {/* Legend */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "8px",
                                }}
                            >
                                {[
                                    { label: `${t.investedAmountLabel}`, color: "#80A8D8" },
                                    { label: `${t.estimatedReturnLabel}`, color: "#097ABE" },
                                ].map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "8px",
                                                backgroundColor: item.color,
                                            }}
                                        />
                                        <Typography
                                            sx={{
                                                fontFamily: "Inter500",
                                                fontSize: "calc(16px + var(--font-delta))",
                                                color: "#09090A",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>

                            :
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "16px",
                                    padding:"20px 0px 20px 0px "
                                }}
                            >
                                {/* PieChart */}
                                <PieChart
                                    series={[
                                        {
                                            data:
                                                calculateSIP()?.investedAmount && calculateSIP()?.estimatedReturns
                                                    ? [
                                                        { label: 'Invested Amount', value: calculateSIP()?.investedAmount, color: "#80A8D8" },
                                                        { label: 'Estimated Return', value: calculateSIP()?.estimatedReturns, color: "#097ABE" },
                                                    ]
                                                    : [],
                                            cy: (window.innerWidth < 500 && 120) || (window.innerWidth < 1000 && 175) || 150,
                                            cx: (window.innerWidth < 500 && 145) || (window.innerWidth < 1000 && 230) || (window.innerWidth < 1100 && 210) || (window.innerWidth < 1300 && 240) || 230,
                                            innerRadius: window.innerWidth < 500 ? 60 : 100,
                                            outerRadius: window.innerWidth < 500 ? 110 : 150,
                                        },
                                    ]}
                                    height={(window.innerWidth < 500 && 250) || (window.innerWidth < 1000 && 350) || 320}
                                    width={(window.innerWidth < 500 && 280) || 455}
                                    slotProps={{
                                        legend: {
                                            hidden: true,
                                        },
                                    }}
                                />

                                {/* Legend */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "16px",
                                    }}
                                >
                                    {[
                                        { label: 'Invested Amount', color: "#80A8D8" },
                                        { label: 'Estimated Return', color: "#097ABE" },
                                    ].map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "8px",
                                                    backgroundColor: item.color,
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontFamily: "Inter500",
                                                    fontSize: "calc(16px + var(--font-delta))",
                                                    color: "#000000",
                                                }}
                                            >
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>



                        }





                        {tabValue !== "4" &&
                            // <BarChart
                            //     xAxis={[{
                            //         scaleType: 'band', data: calculateSIP()?.yearlyReturns?.map((ele, i) => `${i + 1}Y`) || [], disableTicks: false, tickSize: 5, // Add size to ticks
                            //         lineColor: "#D9D9D9",}]}
                            //     yAxis={[{
                            //         disableTicks: true, disableLine: false, lineColor: "#D9D9D9", valueFormatter: (num) => {
                            //             if (num >= 1e7) {
                            //                 return (num / 1e7).toFixed(0) + ' Cr';
                            //             } else if (num >= 1e5) {
                            //                 return (num / 1e5).toFixed(0) + ' L';
                            //             } else if (num >= 1e3) {
                            //                 return (num / 1e3).toFixed(0) + ' K';
                            //             } else {
                            //                 return num.toString();
                            //             }
                            //         }
                            //     }]}
                            //     grid2={{ horizontal: true,
                            //         vertical: true, // Disable vertical gridlines (optional)
                            //         lineColor: "#e0e0e0", // Ensure gridlines are visible
                            //         lineWidth: 1, // Set gridline thickness
                            //      }}
                            //     slotProps={{
                            //         legend: {
                            //             hidden: true
                            //         }
                            //     }}
                            //     series={[
                            //         {
                            //             label: "Invested amount",
                            //             data: calculateSIP()?.yearlyReturns?.map((ele, i) => {
                            //                 if (tabValue=== "2") {
                            //                     if (i === 0) {
                            //                         return ele?.investedAmount;
                            //                     } else {
                            //                         return 0;
                            //                     }
                            //                 }
                            //                 return ele?.investedAmount;
                            //             }) || [], stack: 'A', color: "#80A8D8"
                            //         },
                            //         {
                            //             label: "Estimated returns",
                            //             data: calculateSIP()?.yearlyReturns?.map((ele, i) => {
                            //                 if (tabValue === "2") {
                            //                     if (i === 0) {
                            //                         return Math.abs(ele?.investedAmount - ele?.maturityValue);
                            //                     } else {
                            //                         return Math.abs(ele?.maturityValue);
                            //                     }
                            //                 }
                            //                 return Math.abs(ele?.investedAmount - ele?.maturityValue);
                            //             }) || [], stack: 'A', color: "#097ABE"
                            //         },
                            //     ]}
                            //     height={(window.innerWidth <= 600) && 300 || (window.innerWidth <= 1000) && 400 || 190}
                            // />

                            <BarChart

                                xAxis={[
                                    {
                                        scaleType: 'band',
                                        data: calculateSIP()?.yearlyReturns?.map((ele, i) => `${i + 1}Y`) || [],
                                        disableTicks: true,
                                        disableLine: true,
                                        tickLabelStyle: {
                                            fill: "#999999",
                                            fontWeight: 500,
                                            fontSize: "calc(16px + var(--font-delta))",
                                        },
                                        lineColor: "#ffffff",
                                    },
                                ]}
                                yAxis={[
                                    {
                                        disableTicks: true,
                                        disableLine: true,
                                        lineColor: "#999999",
                                        tickLabelStyle: {
                                            fill: "#999999",
                                            fontWeight: 500,
                                            fontSize: "calc(16px + var(--font-delta))",
                                        },
                                        valueFormatter: (num) => {
                                            if (num >= 1e7) return (num / 1e7).toFixed(0) + ' Cr';
                                            if (num >= 1e5) return (num / 1e5).toFixed(0) + ' L';
                                            if (num >= 1e3) return (num / 1e3).toFixed(0) + ' K';
                                            return num.toString();
                                        },
                                    },
                                ]}

                                grid={{
                                    horizontal: true,
                                    lineColor: "#ffffff",
                                    lineWidth: 1,
                                }}
                                slotProps={{
                                    legend: {
                                        hidden: true,
                                    },
                                }}
                                series={[
                                    {
                                        label: "Invested amount",
                                        data: calculateSIP()?.yearlyReturns?.map((ele, i) => {
                                            if (tabValue === "2") {
                                                return i === 0 ? ele?.investedAmount : 0;
                                            }
                                            return ele?.investedAmount;
                                        }) || [],
                                        stack: 'A',
                                        color: "#80A8D8",
                                    },
                                    {
                                        label: "Estimated returns",
                                        data: calculateSIP()?.yearlyReturns?.map((ele, i) => {
                                            if (tabValue === "2") {
                                                return i === 0
                                                    ? Math.abs(ele?.investedAmount - ele?.maturityValue)
                                                    : Math.abs(ele?.maturityValue);
                                            }
                                            return Math.abs(ele?.investedAmount - ele?.maturityValue);
                                        }) || [],
                                        stack: 'A',
                                        color: "#097ABE",
                                    },
                                ]}
                                height={
                                    (window.innerWidth <= 600 && 300) ||
                                    (window.innerWidth <= 1000 && 300) ||
                                    210
                                }
                            />

                        }
                    </Grid2>

                    <Grid2 display="flex" justifyContent="center">
                        <Button onClick={() => {
                            window.location.href = backendHosts.REG;
                        }} className={styles1.investButton} style={{
                            marginTop: tabValue === "4" ? "80px !important" : "0px !important"
                        }}>
                            {t.investNow}
                        </Button>
                    </Grid2>
                </Grid2>
            </Grid2>
            {/* </MotionGrid> */}
            {/* <Grid2 style={{ width: '100%', background: '#0B1420' }}>
                <Footer />
            </Grid2> */}
        </main>
    );
};

export default withStyles(styles)(MarginCalculator);
